import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Dispatch event when app is mounted
const AppWithMountEvent = () => {
  useEffect(() => {
    // Dispatch custom event to hide loading indicator
    window.dispatchEvent(new Event('app-mounted'));
  }, []);

  return (
    <StrictMode>
      <App />
    </StrictMode>
  );
};

// Create root and render app
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<AppWithMountEvent />);
} else {
  console.error('Failed to find the root element');
}
